import React from 'react';
import { Shield, UserCheck, Trash2, Lock } from 'lucide-react';

const PrivacySection = () => {
  const principles = [
    { number: "1", icon: UserCheck, text: "Semua data diserahkan kepada keluarga" },
    { number: "2", icon: Trash2, text: "Setelah penyerahan, data dihapus menyeluruh" },
    { number: "3", icon: Lock, text: "Tidak ada data yang disimpan" }
  ];

  return (
    <section className="py-20 bg-funeral-dark">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-center gap-3 mb-4">
          <Shield className="text-funeral-gold" size={40} />
          <h2 className="text-4xl md:text-5xl font-serif text-center text-funeral-gold">
            Kerahasiaan Informasi
          </h2>
        </div>
        <div className="divider"></div>

        <div className="max-w-3xl mx-auto text-center mb-12 bg-funeral-secondary/50 p-6 rounded-lg border border-funeral-border">
          <p className="text-funeral-light leading-relaxed mb-2">
            <strong className="text-funeral-gold">Kenangan.AI</strong> menjaga privasi keluarga dan tamu.
          </p>
          <p className="text-funeral-light">
            Data yang masuk bisa berupa: nomor telepon, pesan, doa, foto, video, dan informasi acara.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {principles.map((principle) => {
            return (
              <div 
                key={principle.number}
                className="bg-funeral-secondary p-6 rounded-sm border border-funeral-border text-center hover:border-funeral-gold transition-all group"
              >
                <div className="w-16 h-16 bg-funeral-gold text-funeral-dark rounded-full flex items-center justify-center text-2xl font-serif mx-auto mb-4 group-hover:scale-110 transition-transform">
                  {principle.number}
                </div>
                <p className="text-funeral-light">{principle.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PrivacySection;
